<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ 'APP_INFO_TITLE' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" class="info-content">
  <div class="info-wrapper">
    <div class="version-block">
      <label class="version-label">
        {{ 'Version' | translate }}: {{ appVersion }}
      </label>
    </div>

    <div class="logo-block">
      <img src="assets/images/swisspacer_main.png" alt="Swisspacer logo" />
    </div>

    <div class="company-block">
      <div class="company-text" style="white-space: pre-line;">
        {{ 'APP_INFO_COMPANY_1' | translate }}
      </div>

      <div class="link-list">
        <button type="button" class="link-button"
          (click)="openExternal('http://www.swisspacer.com/')">www.swisspacer.com</button>
        <button type="button" class="link-button" (click)="openMail('info@swisspacer.com')">info@swisspacer.com</button>
        <!-- <button type="button" class="link-button"
          (click)="openExternal('https://www.youtube.com/watch?time_continue=16&v=yB7BAsKQer8')">
          {{ 'APP_INFO_VIDEO_WHO' | translate }}
        </button>
        <button type="button" class="link-button" (click)="openExternal('https://www.youtube.com/watch?v=PFfQTqg4uD0')">
          {{ 'APP_INFO_VIDEO_WARM_EDGE' | translate }}
        </button> -->
      </div>
    </div>

    <!-- <div class="partner-logo-block">
      <img src="assets/images/sommerinformatik.png" alt="Sommer Informatik logo" />
    </div> -->

    <!-- <div class="company-block">
      <div class="company-text" style="white-space: pre-line;">
        {{ 'APP_INFO_COMPANY_2' | translate }}
      </div>

      <div class="link-list">
        <button type="button" class="link-button" (click)="openExternal('http://www.sommer-informatik.de/')">www.sommer-informatik.de</button>
        <button type="button" class="link-button" (click)="openMail('info@sommer-informatik.de')">info@sommer-informatik.de</button>
      </div>
    </div> -->

    <div class="partner-logo-block small">
      <img src="assets/images/bauwerk.png" alt="Bauwerk logo" />
    </div>

    <div class="company-block">
      <div class="company-text" style="white-space: pre-line;">
        {{ 'APP_INFO_COMPANY_3' | translate }}
      </div>

      <div class="link-list">
        <button type="button" class="link-button"
          (click)="openExternal('http://www.waermeschutz.cc/')">www.waermeschutz.cc</button>
        <button type="button" class="link-button"
          (click)="openMail('info@waermeschutz.cc')">info@waermeschutz.cc</button>
      </div>
    </div>

    <div class="about-block" [innerHTML]="appInfoText"></div>
  </div>
</ion-content>